
/* injects from baggage-loader */
require('./style.styl');

import React, {Children, cloneElement} from 'react'
import PropTypes from 'prop-types'
import {getConversionDataForChannel} from 'redux/modules/insights/utils'
import Layer from '../Layer'

export default class FunnelChart extends React.Component {
  static propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    data: PropTypes.object.isRequired,
    loading: PropTypes.bool
  }

  render() {
    const {width, height, data, loading} = this.props

    if (!width || !data || loading) return null

    const funnels = this.getFunnels()
    const funnelsValues = this.getFunnelsData()

    const style = {
      height: height
    }

    return (
      <svg className='funnel-chart' style={style}>
        {this.renderGrid()}
        <Layer className='funnel-chart_funnels'>
          {
            funnels.map((funnel, index) => {
              return cloneElement(funnel, {data: funnelsValues[index], key: index})
            })
          }
        </Layer>
      </svg>
    )
  }

  renderGrid() {
    const {width, data} = this.props
    const gridItemHeight = this.getGridItemHeight()

    return (
      <Layer className='funnel-chart_grid'>
        {
          Object.keys(data).map((el, index) => {
            return (
              <line
                key={index}
                className='funnel-chart_grid_line'
                x1='0'
                y1={index * gridItemHeight}
                x2={width}
                y2={index * gridItemHeight} />
            )
          })
        }
      </Layer>
    )
  }

  getFunnelsData() {
    const funnels = this.getFunnels()
    const {width, data} = this.props
    const gridItemHeight = this.getGridItemHeight()

    return funnels.map(funnel => {
      const {dataKey} = funnel.props

      const funnelData = getConversionDataForChannel(data, dataKey)
      if (!funnelData) return null

      const maxValue = funnelData[0]
      return funnelData.reduce((acc, value, index) => {
        const x = (width - (width * (value / maxValue))) / 2
        const y = index * gridItemHeight
        if (index === (funnelData.length - 1)) {
          return {
            left: [...acc.left, {x, y}, {x, y: y + gridItemHeight}],
            right: [
              {x: (width - x), y: y + gridItemHeight},
              {x: (width - x), y},
              ...acc.right
            ]
          }
        } else {
          return {
            left: [...acc.left, {x, y}],
            right: [{x: (width - x), y}, ...acc.right]
          }
        }
      }, {left: [], right: []})
    })
  }

  getFunnels() {
    return Children.toArray(this.props.children)
  }

  getGridItemHeight() {
    const {height, data} = this.props

    return height / Object.keys(data).length
  }
}



// WEBPACK FOOTER //
// ./client/components/Chart/FunnelChart/index.js